import Layout from "@components/Layout"
import RadioInputButton from "@components/RadioInputButton"
import { useTranslation } from "react-i18next"
import { Form, useSubmit } from "react-router-dom"

export default function GenderPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    submit(event.currentTarget.form)
  }

  return (
    <Layout withLoginHeader>
      <div className="shrink-0">
        <h1 className="custom-heading">
          {t("pages.onboarding.gender.heading")}
        </h1>
      </div>

      <Form className="flex grow flex-col justify-center gap-5" method="post">
        <RadioInputButton
          className="from-pd-orange"
          emoji="👩"
          label={t("pages.onboarding.gender.female")}
          name={t("pages.onboarding.gender.heading", { lng: "en" })}
          onChange={handleChange}
          value={t("pages.onboarding.gender.female", { lng: "en" })}
        />

        <RadioInputButton
          className="from-pd-yellow"
          emoji="👱‍♂️"
          label={t("pages.onboarding.gender.male")}
          name={t("pages.onboarding.gender.heading", { lng: "en" })}
          onChange={handleChange}
          value={t("pages.onboarding.gender.male", { lng: "en" })}
        />

        <RadioInputButton
          className="from-pd-peach"
          emoji="👱‍♂️"
          label={t("pages.onboarding.gender.other")}
          name={t("pages.onboarding.gender.heading", { lng: "en" })}
          onChange={handleChange}
          value={t("pages.onboarding.gender.other", { lng: "en" })}
        />
      </Form>
    </Layout>
  )
}
